import CustomDrawer from "../../../components/custom-drawer/CustomDrawer";
import { PersonSvg} from "../../../assets/common-svg/CommonSvg";
import HeaderBackNav from "../../../components/header-back-navigation/HeaderBackNav";
import CustomSearchbar from "../../../components/custom-searchbar/CustomSearchbar";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import {  useState } from "react";
import {Typography } from "@mui/material";

const ListAssignedPM = ({loading=false, openEditorDrawer, setOpenEditorDrawer,editorDrawerData}) =>{
  const [editorSearch, setEditorSearch] = useState("");


    const filteredEditorDrawerData = editorDrawerData.filter(editor =>
    (editor.name?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
    (editor.role?.toLowerCase() || "").includes(editorSearch.toLowerCase())
  );

    return (
           <CustomDrawer open={openEditorDrawer} toggleDrawer={() => setOpenEditorDrawer(!openEditorDrawer)}>
                <div className="w-[25rem]">
                  <div className="pl-4 pt-4 pr-4">
                    <HeaderBackNav
                      handleBackNav={() => setOpenEditorDrawer(false)}
                      TitleFontSize={"18px"}
                      TitleFontWeight={700}
                      Title="Editor/Patient Navigators Details"
                    />
                  </div>
                  <hr />
                  <div className="pl-3 pt-3 pr-3">
                    <CustomSearchbar
                      Placeholder="Search by Name or Role"
                      BgColor="#dfe0eb"
                      value={editorSearch}
                      handleSearch={(value) => setEditorSearch(value)}
                    />
                    <ul className="p-2 cursor-pointer">
                      {loading ? (
                        <SkeletonLoader rowCount={1} height={"35px"} />
                      ) : filteredEditorDrawerData?.length === 0 ? (
                        <div className="mt-4">
                          <Typography variant="body1" className="text-center text-gray-500">
                            No details available
                          </Typography>
                        </div>
                      ) : (
                        filteredEditorDrawerData?.map((editor, index) => (
                          <li
                            key={editor?.id || index}
                            className="flex gap-3 align-center pt-2 pb-2"
                            style={{ borderBottom: "2px solid #dfe0eb" }}
                          >
                            <div className="self-center">
                              <PersonSvg />
                            </div>
                            <div className="self-center">
                              <Typography variant="h6">
                                {editor?.name || "Name not available"}
                              </Typography>
                              {editor?.role && (
                                <Typography variant="body2" color="textSecondary">
                                  Role: {editor.role}
                                </Typography>
                              )}
                            </div>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>
              </CustomDrawer>
    )
}
export default ListAssignedPM